import { useNavigate } from "react-router-dom";
import ActionMenu from "../../../../../components/actionMenu/ActionMenu";
import { FleetDataInterface } from "../../../../../redux/interfaces/fleet.interface";
import { reportsRoutes } from "../../../../../router/routesConstants";

function CargoCarActionsButtons({
  itemId,
  crudData,
}: {
  itemId: string;
  crudData: FleetDataInterface;
}) {
  const navigate = useNavigate();

  const handleGoToCargo = () => {
    navigate(
      `${itemId}/${reportsRoutes.cargo}?idAuto=${itemId}&nrAuto=${crudData.nrauto}`,
    );
  };

  return (
    <ActionMenu
      title={crudData.nrauto}
      items={[
        {
          id: "view-cargo",
          label: "Vezi marfa",
          icon: "PACKAGES",
          tooltip: "Deschide lista marfurilor incarcate in acest autovehicul.",
          onClick: handleGoToCargo,
        },
      ]}
    />
  );
}

export default CargoCarActionsButtons;
